<button mat-button [matMenuTriggerFor]="clientMenu">
	Please select a client to continue
	<mat-icon class="ml-8" title="Open menu">expand_more</mat-icon>
</button>


<mat-menu #clientMenu="matMenu">
	<button mat-menu-item *ngFor="let client of (clients$ | async)" (click)="selectClient(client)" class="client-name">
		{{ client }}
	</button>
</mat-menu>
